import type { ShowcaseProduct } from "../../../pages/ShowcasePage/types";
import { CoverageButton } from "../../shared/CoverageButton";
import { Text, Box, Flex } from "@simplybusiness/mobius";

export interface ShowcaseProductsListProps {
  products: ShowcaseProduct[];
  onOpenDrawer: (id: string, title: string, content: string) => void;
}

export const ShowcaseProductsList = ({
  products,
  onOpenDrawer,
}: ShowcaseProductsListProps) => (
  <Box
    className="mobius-showcase-products-list"
    data-testid="mobius-showcase-products-list"
  >
    {products.map((product, index) => (
      <Flex
        key={index}
        className="mobius-showcase-product-list__item"
        gap="sm"
        flexDirection="column"
      >
        <div>
          <Text className="mobius-title__header mobius-product-list__item-title">
            {product.productDisplayName}
          </Text>
          {[product.coverageLimit].flat().map((limit, limitIndex) => (
            <Text
              key={limitIndex}
              elementType="p"
              className="mobius-title__description mobius-product-list__coverage-limit"
            >
              {limit}
              <sup>&dagger;</sup>
            </Text>
          ))}
        </div>
        <CoverageButton
          productCode={product.insuranceAdvisorProductCode}
          onClick={() =>
            onOpenDrawer(
              product.id,
              product.modalTitle,
              product.productInformation,
            )
          }
          className="mobius-product-list__drawer-trigger"
        />
      </Flex>
    ))}
  </Box>
);
